import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MyWorkPage } from '@/features/insights/my-work-page';

export const Route = createFileRoute('/_app/my-work')({
  validateSearch: z.object({
    /** D40: the list by due date (MYW-2), or a board by status. */
    view: z.enum(['list', 'board']).optional(),
  }),
  component: MyWorkPage,
});
